import axios from "axios";
//const API_BASE_URL = "http://192.168.0.154:3001/api/v1/";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_TOKEN  = localStorage.getItem(`token`);
console.log("API_BASE_URL", API_TOKEN);
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    ...(API_TOKEN && { Authorization: `Bearer ${API_TOKEN}` }),
  },
});
export default api;
